addEventListener('submit', e => {
  if (e.target.matches('#user-cedar-search')) {
    e.preventDefault()
    const { action, method } = e.target

    fetch(action, { method, body: new FormData(e.target) })
      .then(resp => {
        if (resp.ok) return resp.text()
      })
      .then(text => {
        document.getElementById('lookup-results').innerHTML = text
      })
  }
})
